<template>
  <div class="container-fluid">
    <prescription-form-print
      v-if="isCreated"
      :selectedPatient="selectedPatient"
      :patientConfig="patient"
      :generalConfig="general"
      :selectedPrescription="selectedPrescription"
      @print="removeInvoiceFromInvoicePrintMap"
    />
  </div>
</template>

<script>
import PrescriptionFormPrint from '@/components/Print/PrescriptionFormPrint.vue';
import invoicePrintMixins from '@/components/mixins/invoice-print';
import { mapGetters } from 'vuex';

export default {
  name: 'PrescriptionForm',
  mixins: [invoicePrintMixins],
  components: {
    PrescriptionFormPrint,
  },
  data() {
    return {
      isCreated: false,
      selectedPrescription: {},
    };
  },
  computed: {
    ...mapGetters('patient', ['selectedPatient']),
    ...mapGetters('config', ['general', 'patient']),
  },
  async created() {
    const vm = this;
    this.setInvoiceForPrinting()
    vm.selectedPrescription = Object.assign({}, this.print); /* eslint-disable-line no-restricted-globals */
    this.isCreated = true;
  },
};
</script>
